export default `
  @font-face {
    font-family: 'ProximaNova';
    src: url('https://doxy.me/bundle/spec_assets/fonts/ProximaNova-Regular.ttf') format('ttf');
  }
`;
